// import React, { useContext } from "react";
// import Header from "../Components/Header";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Support = ({ handleShow }) => {
//   const theme = localStorage.getItem('theme')

//   // language 
//   const translations = {
//     hi: {
//       contact: 'नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।',
//       money: 'राशि डालें  ',
//       next: 'आगे बड़े ',
//       addAmount: 'राशि जोड़ी जानी है ',
//       referPerson: 'रेफ़रल | ',
//     },
//     en: {
//       contact: 'Contact Us At Below Platforms.',
//       money: 'Enter Amount',
//       next: 'Next',
//       addAmount: 'Amount to be added',
//       referPerson: 'Referral',
//     },
//   };

//   const { language } = useContext(LanguageContext);


//   // change theme 
//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };

//   return (
//     <div>
//       <div
//         className="leftContainer pt-5 mt-5"
//         style={styles}
//       >
//         <div className="supportNewLayout">

//           {/* TOP INFO CARD */}
//           <div className="helpTopCard">
//             <div className="helpLeftBar"></div>

//             <div className="helpContent">
//               <img src="./images/support.jpg" className="helpImg" />
//               <div>
//                 <h2 className="helpTitle">Need Help?</h2>
//                 <p className="helpSub">We are here for you 24/7</p>
//               </div>
//             </div>
//           </div>

//           {/* SUPPORT GRID */}
//           <div className="supportOptionGrid">

//             {/* Teligram */}
//             <a className="supportOptionCard" href={JSON.parse(localStorage.getItem("sitSetting")).supportTelegram}>
//               <div className="supportIcon emailBG">
//                 <img src="./images/telegram.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Telegram Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a>

//             {/* WhatsApp */}
//             {JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport && (
//               <a
//                 className="supportOptionCard"
//                 target="_blank"
//                 href={JSON.parse(localStorage.getItem("sitSetting")).whatsappSupport}
//               >
//                 <div className="supportIcon">
//                   <img src="/images/whatsapp-new-.png" alt="" />
//                 </div>
//                 <div className="supportText">
//                   <h5>WhatsApp</h5>
//                   <span>Chat with us instantly</span>
//                 </div>
//               </a>
//             )}



            
//           </div>

//           {/* Email */}
//           {/* <a className="supportOptionCard" href="mailto:support@gmail.com">
//               <div className="supportIcon emailBG">
//                 <img src="./images/mail-new.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Email Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a> */}

//           {/* PHONE SUPPORT */}
//           {/* <div className="phone-banner">

//             <div className="phone-anim">
//               <img src="/images/phone.png" alt="" />
//             </div>

//             <div className="phone-content">
//               <span>Need direct help?</span>
//               <h4 style={{ margin: 0, fontWeight: 700 }}>Phone Support</h4>

//               <a
//                 className="phone-number"
//                 href={
//                   "tel:" +
//                   JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//                 }
//                 target="_blank"
//               >
//                 {JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile}
//               </a>
//             </div>

//             <a
//               href={
//                 "tel:" +
//                 JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//               }
//               className="call-btn"
//             >
//               Call Now
//             </a>

//           </div> */}

//         </div>

//       </div>
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;

import React, { useContext } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
import { BsArrowRightShort } from "react-icons/bs";

const Support = () => {
  const { language } = useContext(LanguageContext);
  const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      help: 'सपोर्ट सेंटर',
      sub: 'हम आपकी सहायता के लिए 24x7 यहां हैं',
      team: 'हमारी सहायता टीम',
      replies: 'आमतौर पर 2 मिनट में उत्तर देता है',
      telegram: 'Telegram Support',
      official: 'Official Channel',
      contact: 'Contact Us',
      voice: 'Voice Assistance',
      secure: 'SECURE & VERIFIED SUPPORT'
    },
    en: {
      help: 'SUPPORT CENTER',
      sub: 'We are available 24x7 to help you',
      team: 'Our Support Team',
      replies: 'Typically replies in 2 mins',
      telegram: 'Telegram Support',
      official: 'Official Channel',
      contact: 'Contact Us',
      voice: 'Voice Assistance',
      secure: 'SECURE & VERIFIED SUPPORT'
    },
  };

  const t = translations[language] || translations.en;

  return (
    <>
      {/* Inline Style Block matching the premium wallet system aesthetics */}
      <style>
        {`
          .premium-support-container {
            background: linear-gradient(135deg, #0a0f1c 0%, #000000 100%);
            min-height: 100vh;
            color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow-x: hidden;
          }
          
          .float-anim {
            animation: floatUpDown 3s ease-in-out infinite;
          }
          
          .pulse-glow {
            animation: pulseGlow 2s infinite;
          }

          .slide-up {
            animation: slideUp 0.6s ease-out forwards;
          }

          .glass-card {
            background: rgba(20, 25, 40, 0.7);
            backdrop-filter: blur(10px);
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 0 15px 35px rgba(0,0,0,0.5);
            transition: all 0.3s ease;
          }

          .glass-card:hover {
            transform: translateY(-5px);
          }

          .support-cards-grid {
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 100%;
          }

          .action-card-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-decoration: none;
            padding: 16px 20px;
            border-radius: 12px;
            transition: all 0.3s ease;
          }

          .telegram-theme {
            background: rgba(0, 136, 204, 0.1);
            border: 1px solid rgba(0, 136, 204, 0.2);
          }
          .telegram-theme:hover {
            background: rgba(0, 136, 204, 0.2);
            box-shadow: 0 5px 15px rgba(0, 136, 204, 0.2);
            border-color: rgba(0, 136, 204, 0.4);
          }

          .whatsapp-theme {
            background: rgba(37, 211, 102, 0.1);
            border: 1px solid rgba(37, 211, 102, 0.2);
          }
          .whatsapp-theme:hover {
            background: rgba(37, 211, 102, 0.2);
            box-shadow: 0 5px 15px rgba(37, 211, 102, 0.2);
            border-color: rgba(37, 211, 102, 0.4);
          }

          @media (max-width: 600px) {
            .support-card-padding {
              padding: 15px 12px !important;
            }
            .support-title-text {
              font-size: 22px !important;
            }
          }

          @keyframes floatUpDown {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }

          @keyframes pulseGlow {
            0% { box-shadow: 0 0 0 0 rgba(0, 255, 136, 0.4); }
            70% { box-shadow: 0 0 0 10px rgba(0, 255, 136, 0); }
            100% { box-shadow: 0 0 0 0 rgba(0, 255, 136, 0); }
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="premium-support-container leftContainer mt-5 pt-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 100%', maxWidth: '650px', margin: '0 auto', padding: '20px' }}>
          
          {/* Header & Animated Center Asset */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }} className="slide-up">
            <img 
              src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2I4Y2QxZjc1MmY0MTI4ODcxMDU1M2Y2Y2RiYTZjZGI3MThjZjhhZCZlcD12MV9pbnRlcm5hbF9naWZzX3NlYXJjaCZjdD1n/L1R1tvI9svkVDsPRkL/giphy.gif" 
              alt="Support Center Asset" 
              className="float-anim"
              style={{ width: '70px', height: '70px', objectFit: 'contain', filter: 'drop-shadow(0px 10px 10px rgba(0,191,255,0.3))' }}
            />
            <h2 className="support-title-text" style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 5px 0', color: '#fff', textTransform: 'uppercase', letterSpacing: '1px' }}>
              My <span style={{ color: '#f0c022' }}>{t.help.split(' ')[1] || 'Support'}</span>
            </h2>
            <p style={{ color: '#8892b0', fontSize: '13px', margin: '0' }}>{t.sub}</p>
          </div>

          {/* Active Support Team Status Banner */}
          <div 
            className="glass-card slide-up support-card-padding" 
            style={{ display: 'flex', alignItems: 'center', padding: '15px 20px', marginBottom: '25px', borderLeft: '4px solid #00ff88', animationDelay: '0.1s' }}
          >
            <div style={{ position: 'relative', marginRight: '15px' }}>
              <img 
                src="/images/support.jpg" 
                alt="Support Team" 
                style={{ width: '50px', height: '50px', borderRadius: '50%', objectCover: 'cover', border: '2px solid #00ff88' }} 
              />
              <div 
                className="pulse-glow" 
                style={{ position: 'absolute', bottom: '-2px', right: '-2px', background: '#00ff88', borderRadius: '50%', width: '12px', height: '12px', border: '2px solid #0a0f1c' }}
              />
            </div>
            <div>
              <div style={{ color: '#fff', fontSize: '15px', fontWeight: 'bold' }}>{t.team}</div>
              <div style={{ color: '#00ff88', fontSize: '12px', fontWeight: '500', marginTop: '2px' }}>● {t.replies}</div>
            </div>
          </div>

          {/* Connected Channels Grid Block */}
          <div className="support-cards-grid slide-up" style={{ animationDelay: '0.2s' }}>
            
            {/* Telegram Anchor Element Card */}
            {siteSetting.supportTelegram && (
              <a 
                href={siteSetting.supportTelegram} 
                className="glass-card action-card-btn telegram-theme" 
                target="_blank" 
                rel="noreferrer"
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{ background: 'rgba(0, 136, 204, 0.15)', width: '45px', height: '45px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src="/tel.png" alt="Telegram Icon" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ color: '#fff', fontWeight: '700', fontSize: '15px' }}>{t.telegram}</div>
                    <div style={{ color: '#8892b0', fontSize: '12px', marginTop: '2px' }}>{t.official}</div>
                  </div>
                </div>
                <BsArrowRightShort style={{ color: '#0088cc', fontSize: '24px' }} />
              </a>
            )}

            {/* WhatsApp Contact Element Card */}
            {siteSetting.whatsappSupport && (
              <a 
                href={siteSetting.whatsappSupport} 
                className="glass-card action-card-btn whatsapp-theme" 
                target="_blank" 
                rel="noreferrer"
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{ background: 'rgba(37, 211, 102, 0.15)', width: '45px', height: '45px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src="/whatsapp.png" alt="WhatsApp Icon" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ color: '#fff', fontWeight: '700', fontSize: '15px' }}>{t.contact}</div>
                    <div style={{ color: '#8892b0', fontSize: '12px', marginTop: '2px' }}>{t.voice}</div>
                  </div>
                </div>
                <BsArrowRightShort style={{ color: '#25d366', fontSize: '24px' }} />
              </a>
            )}

          </div>

          {/* Secure Verified Security Footer */}
          <div className="slide-up" style={{ textAlign: 'center', marginTop: '35px', animationDelay: '0.3s' }}>
            <p style={{ color: '#4a5568', fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', textTransform: 'uppercase' }}>
              <span>🛡️</span> {t.secure}
            </p>
          </div>

        </div>

        {/* Global Sidebar Platform Wrapper */}
        <div className="rightContainer hidden-mobile mobile-hide" style={{ flex: '0 0 auto' }}>
          <Rightcontainer />
        </div>
      </div>
    </>
  );
};

export default Support;
